<template>
    <div id="footer">
        <p id="copyright">&copy; Copyright {{theDate}}. All Rights Reserved</p>
    </div>
</template>

<script>
    export default {
        name: "FooterDisplay",
        components: {

        },
        data () {
            return {

            } 
        },
        computed: {
            theDate () {
                return (new Date()).getFullYear()
            }
        },
        methods: {

        }    
    }
</script>

<style scoped lang="scss">
    #footer {
        border-top: #dddddd 1px solid;
        box-shadow: 0 1px 2px 1px rgb(0 0 0 / 20%);
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        background: white;
        z-index: 99999;

        p { margin: 0; }
    }

    #copyright { font-size: 12px; }
</style>